import axios from 'axios';

// ─── Base URL ─────────────────────────────────────────────────────────────────
// In production CRA builds, set REACT_APP_API_URL in your .env
// e.g. REACT_APP_API_URL=https://admin.iconecc.co.in/backend/api/v1
const BASE_URL = process.env.REACT_APP_API_URL || '/backend/api/v1';

const api = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' },
  timeout: 15000,
});

// ─── Request interceptor — attach JWT ────────────────────────────────────────
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('icon_auth_token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

// ─── Response interceptor — handle 401 globally ──────────────────────────────
api.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('icon_auth_token');
      // Clear zustand persisted auth
      try {
        const raw = localStorage.getItem('icon-admin-auth');
        if (raw) {
          const parsed = JSON.parse(raw);
          parsed.state = { user: null, token: null, isAuth: false };
          localStorage.setItem('icon-admin-auth', JSON.stringify(parsed));
        }
      } catch (_) {}
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
